"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsyncConnection = void 0;
const activeAsyncConnection_1 = require("../../../activeAsyncConnection");
const types_1 = require("./types");
const buildAsyncConnectionConfig = (apiCall) => ({
    mode: activeAsyncConnection_1.AsyncConnectionMode.POLLING,
    pollingConfig: {
        interval: 5000,
        maxAttempts: 180,
        getDataFn: async () => {
            const response = await apiCall();
            return response.data;
        },
    },
});
const buildAsyncConnectionEvents = (verifyActions) => ({
    onReceiveData: response => {
        verifyActions.onSuccess(response.message, types_1.AssistedLoginVerifyModeType.POLLING);
    },
    onError: () => verifyActions.onError(undefined, types_1.AssistedLoginVerifyModeType.POLLING),
});
const getAsyncConnection = async ({ apiCall, verifyActions, }) => {
    const asyncConnection = new activeAsyncConnection_1.AsyncConnection(buildAsyncConnectionConfig(apiCall));
    const connection = asyncConnection.getConnection();
    await connection.connect();
    connection.listen(buildAsyncConnectionEvents(verifyActions));
    return connection;
};
exports.getAsyncConnection = getAsyncConnection;
//# sourceMappingURL=biometricValidation.helper.js.map